import { render, staticRenderFns } from "./HerstellerKundenumsaetze.vue?vue&type=template&id=bbd66682&"
import script from "./HerstellerKundenumsaetze.vue?vue&type=script&lang=js&"
export * from "./HerstellerKundenumsaetze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports